import { StyleSheet, TextStyle, ViewStyle } from 'react-native';
import theme from './theme';

const MODIFIER_STYLE_COLOURS = theme.colors.pools.modifiers;

// Predefined text/swatch styles keyed by each palette hex, so components can
// select a StyleSheet entry by colour instead of allocating an inline style
// object per render. Keys are uppercased (the validator accepts colours
// case-insensitively) so a persisted lowercase hex still resolves.
// ~15% opacity tint, expressed as an 8-digit hex alpha suffix so the palette
// colour itself doesn't need a second, separate "background colour" value.
const BACKGROUND_ALPHA_HEX = '26';

const textEntries: Record<string, TextStyle> = {};
const swatchEntries: Record<string, ViewStyle> = {};
const backgroundEntries: Record<string, ViewStyle> = {};
MODIFIER_STYLE_COLOURS.forEach(({ color }) => {
  textEntries[color.toUpperCase()] = { color };
  swatchEntries[color.toUpperCase()] = { backgroundColor: color };
  backgroundEntries[color.toUpperCase()] = {
    backgroundColor: `${color}${BACKGROUND_ALPHA_HEX}`,
  };
});

export const modifierTextColorStyles = StyleSheet.create(textEntries);
export const modifierSwatchColorStyles = StyleSheet.create(swatchEntries);
export const modifierBackgroundColorStyles =
  StyleSheet.create(backgroundEntries);

/** Returns the text style for a palette colour, case-insensitively. */
export function modifierTextColorStyle(
  color: string | undefined,
): TextStyle | undefined {
  return color ? modifierTextColorStyles[color.toUpperCase()] : undefined;
}

/** Returns the swatch style for a palette colour, case-insensitively. */
export function modifierSwatchColorStyle(
  color: string | undefined,
): ViewStyle | undefined {
  return color ? modifierSwatchColorStyles[color.toUpperCase()] : undefined;
}

/** Returns the tinted background style for a palette colour, case-insensitively. */
export function modifierBackgroundColorStyle(
  color: string | undefined,
): ViewStyle | undefined {
  return color ? modifierBackgroundColorStyles[color.toUpperCase()] : undefined;
}
